// extracted by mini-css-extract-plugin
module.exports = {"box":"vehicles_box__3Qs5Z","model":"vehicles_model__F5p69","back":"vehicles_back__34Ch0"};